import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { ApiService } from '@quorum/api';
import { AuthenticationStateService } from '@quorum/authentication/services';
import { LicenseQueryParameters, ProductQueryParameters } from '@quorum/models/xs-query';
import { RouterStateService } from '@quorum/sha-router';
import { Observable } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';

@Injectable()
export class LicenseGuard implements CanActivate, CanActivateChild {
  private isAuthenticated: boolean;

  constructor(
    private authenticationStateService: AuthenticationStateService,
    private router: Router,
    private routerStateService: RouterStateService,
    private apiService: ApiService
  ) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    // return true;//this.isAuthenticated;
    // you can return an observable, so you just need that stream to give you
    //  the current value of authenticated from store and then map that to true/false with
    //  your side effect of router navigate if false.
    return this.authenticationStateService.selectAuthenticatedUser().pipe(
      filter((user) => user != null),
      switchMap((tokenUser: any) => {
        let params: ProductQueryParameters = new ProductQueryParameters({ name: 'PowerLane' });
        return this.apiService.get('quorum/products', { params: params }).pipe(
          switchMap((products) => {
            let powerLane = products[0];
            let licenseParams: LicenseQueryParameters = new LicenseQueryParameters({
              storeId: tokenUser.user.storeId,
              productId: powerLane.id,
            });
            return this.apiService.get('quorum/store/licenses', { params: licenseParams }).pipe(
              map((licenses) => {
                if (licenses.length == 0) {
                  this.routerStateService.go(['/no-license'], {});
                  return false;
                } else {
                  return true;
                }
              })
            );
          })
        );
      })
    );
    // return this.authenticationStateService.selectAuthenticatedEmployee().pipe(
    //   filter(employee => employee != null),
    //   map((employee: any) => {
    //     if (employee.jobTitleId == 'TCH') {
    //       this.routerStateService.go(['/tech'], {});
    //       return false;
    //     } else {
    //       return true;
    //     }

    //     // if (value) {
    //     //   return true;
    //     // } else {
    //     //   this.routerStateService.go(['/login'], {});
    //     //   return false;
    //     // }
    //   })
    // );
    // .take(1) // this should allow you to grab the current value each time canActivate is run
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate(next, state);
  }
}
